import React from 'react';
import { useTranslation } from 'react-i18next';

export default function Terms() {
  const { t } = useTranslation();
  const lastUpdated = '2025-09-29';
  const company = 'JustDev OÜ';
  const regCode = '16241237';
  const address = 'Liivaoja 4b, 10155 Tallinn, Estonia';
  const domain = 'threatcompass.eu';
  const contact = 'contact@threatcompass.eu';

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white rounded-2xl shadow-lg p-8">
          <div className="mb-4">
            <h1 className="text-2xl font-bold text-gray-900">{t('legal.terms.title')}</h1>
          </div>
          <p className="text-sm text-gray-500 mb-8">{t('legal.lastUpdated', { date: lastUpdated })}</p>

          <p className="text-gray-700 mb-4">
            {t('legal.terms.intro', { domain, company, regCode, address })}
          </p>

          <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-2">{t('legal.terms.s1Title')}</h2>
          <p className="text-gray-700 mb-4">{t('legal.terms.s1Body')}</p>

          <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-2">{t('legal.terms.s2Title')}</h2>
          <p className="text-gray-700 mb-4">{t('legal.terms.s2Body')}</p>

          <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-2">{t('legal.terms.s3Title')}</h2>
          <p className="text-gray-700 mb-4">{t('legal.terms.s3Body')}</p>

          <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-2">{t('legal.terms.s4Title')}</h2>
          <p className="text-gray-700 mb-4">{t('legal.terms.s4Body')}</p>

          <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-2">{t('legal.terms.s5Title')}</h2>
          <p className="text-gray-700 mb-4">{t('legal.terms.s5Body')}</p>

          <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-2">{t('legal.terms.s6Title')}</h2>
          <p className="text-gray-700 mb-4">{t('legal.terms.s6Body')}</p>

          <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-2">{t('legal.terms.s7Title')}</h2>
          <p className="text-gray-700 mb-4">{t('legal.terms.s7Body')}</p>

          <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-2">{t('legal.terms.s8Title')}</h2>
          <p className="text-gray-700 mb-4">{t('legal.terms.s8Body')}</p>

          <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-2">{t('legal.terms.s9Title')}</h2>
          <p className="text-gray-700 mb-4">{t('legal.terms.s9Body')}</p>

          <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-2">{t('legal.terms.s10Title')}</h2>
          <p className="text-gray-700 mb-4">{t('legal.terms.s10Body')}</p>

          <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-2">{t('legal.terms.s11Title')}</h2>
          <p className="text-gray-700">{t('legal.terms.s11Body', { company, address, contact })}</p>
          <p className="text-xs text-gray-400 mt-6">
            Favicon: <a className="underline" href="https://icons8.com/icon/HdeK0DkDR02b/radar" target="_blank" rel="noreferrer">Radar</a> icon by{' '}
            <a className="underline" href="https://icons8.com" target="_blank" rel="noreferrer">Icons8</a>.
          </p>
        </div>
      </div>
    </div>
  );
}
